module["exports"] = [
  "gmail.com",
  "yahoo.ca",
  "hotmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/internet/free_email.js
// module id = 1097
// module chunks = 0